export default __webpack_public_path__ + "static/media/gallery-wip-neck_02.8c0deab4.jpg";